// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__hsxBY","header__link":"styles_header__link__15yyI","header__linkText":"styles_header__linkText__2mEby"};